module.exports = __webpack_public_path__ + "img/2X.f6ea87b2.jpg";